import React from "react"

import RmExportButton from "./RmExportButton"
import classes from "./RmFooter.module.scss"

const RmFooter = (props) => {
  const { ordersForDispatch, setOrdersForDispatch } = props

  return (
    <div className={classes["footer"]}>
      <RmExportButton
        ordersForDispatch={ordersForDispatch}
        setOrdersForDispatch={setOrdersForDispatch}
      />
    </div>
  )
}

export default RmFooter